import script from "./bundle2biz.vue?vue&type=script&lang=js"
export * from "./bundle2biz.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__